import React from 'react';
import { CheckIcon } from 'lucide-react';
import { pricing } from '../data/content';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
const offerItems = ['6 módulos especializados', '+400 páginas de material profesional', `5 bonos profesionales GRATIS — valorados en ${pricing.bonusTotal}`, 'Acceso inmediato', 'Acceso de por vida'];
export function Offer() {
  return <section id="oferta" className="scroll-mt-16 bg-paper py-20 sm:py-24" aria-labelledby="offer-title" data-id="element-147" data-mp="tzwhnj3w16h1">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-148" data-mp="p0tk0jq8m2j3">
        <div className="text-center" data-id="element-149" data-mp="13wre7wglowso">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-150" data-mp="13xsq235fxnbg">Acceso completo a Maestro de Sesiones</p>
          <h2 id="offer-title" className="mt-4 text-balance font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-151" data-mp="ywmw6201nu0c">
            Todo el sistema por solo <em className="text-terra" style={{
            fontWeight: "500"
          }} data-id="element-152" data-mp="2adwdoizm4bz0">{pricing.today}</em>
          </h2>
        </div>

        <div className="mt-10 rounded-[2rem] bg-cream p-7 shadow-soft ring-1 ring-cream-line sm:p-12" data-id="element-153" data-mp="pj5v4pirqkej">
          <ul className="mx-auto max-w-md space-y-3" data-id="element-154" data-mp="ui0j05vlez5i">
            {offerItems.map(item => <li key={item} className="flex items-start gap-3 text-lg text-petrol" data-id="element-155" data-mp="zjpypytrg0zx">
                <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-deep text-paper" data-id="element-156" data-mp="13k9rkq7awig9">
                  <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-157" data-mp="6vahr6r2j8ly" />
                </span>
                {item}
              </li>)}
          </ul>

          <div className="mt-10 border-t border-cream-line pt-10 text-center" data-id="element-158" data-mp="ftcqy9kyh7kb">
            <p className="font-display leading-none text-petrol" data-id="element-159" data-mp="klnpb801slar">
              <span className="mr-3 align-middle text-2xl text-terra sm:text-3xl" data-id="element-160" data-mp="kmyy5m8coj8q">HOY:</span>
              <span className="text-6xl sm:text-7xl" style={{
              fontSize: "40px"
            }} data-id="element-161" data-mp="3k6t4u8vu718t">{pricing.today}</span>
            </p>
            <p className="mx-auto mt-5 w-fit rounded-md bg-sage-wash px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-sage-deep" data-id="element-162" data-mp="vfh5ia2boxke">
              Pago único · Sin suscripciones
            </p>
            <div className="mt-8" data-id="element-163" data-mp="15620zomp9lz3">
              <CtaButton checkout block data-id="element-164" data-mp="1548v4bjwv5s5">
                Quiero acceder a Maestro de Sesiones
              </CtaButton>
            </div>
            <div className="mt-5" data-id="element-165" data-mp="108ti1ltq9dws">
              <TrustRow data-id="element-166" data-mp="cg37nh1h32om" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}